import React from 'react';
import { Box } from '@mui/material';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Hoisted memoized map component to prevent re-creation on parent re-renders
const EventMap = React.memo(({ latitude, longitude }) => {
  const ref = React.useRef(null);
  const mapRef = React.useRef(null);
  const markerRef = React.useRef(null);
  const timeoutRef = React.useRef(null);

  React.useEffect(() => {
    if (typeof latitude !== 'number' || typeof longitude !== 'number') return;
    if (!ref.current) return;
    if (mapRef.current) {
      // update existing map only
      mapRef.current.setView([latitude, longitude], mapRef.current.getZoom());
      if (markerRef.current) markerRef.current.setLatLng([latitude, longitude]);
      return;
    }
    L.Icon.Default.mergeOptions({ iconRetinaUrl: markerIcon2x, iconUrl: markerIcon, shadowUrl: markerShadow });
    const map = L.map(ref.current, { center: [latitude, longitude], zoom: 12 });
    mapRef.current = map;
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution: '&copy; OpenStreetMap contributors' }).addTo(map);
    markerRef.current = L.marker([latitude, longitude]).addTo(map);
    timeoutRef.current = setTimeout(() => {
      try { if (map && map._container && map._mapPane) map.invalidateSize(); } catch (e) {}
    }, 120);
    return () => {
      if (timeoutRef.current) { clearTimeout(timeoutRef.current); timeoutRef.current = null; }
      try { map.remove(); } catch (e) {}
      mapRef.current = null;
      markerRef.current = null;
    };
  }, [latitude, longitude]);

  return <Box ref={ref} sx={{ height: 260, minHeight: 260, borderRadius: 1, overflow: 'hidden', bgcolor: 'background.default' }} />;
}, (prev, next) => prev.latitude === next.latitude && prev.longitude === next.longitude);

EventMap.displayName = 'EventMap';

export default EventMap;

